import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import { debounce } from "legacy/helpers.es6"
import ContactList from "legacy/manage/ContactList"
import CreateCustomerModal from "legacy/manage/CreateCustomerModal"
import PropTypes from "prop-types"
import React from "react"

class SearchCustomerForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      contacts: [],
      safeHarborContacts: [],
      users: [],
      archivedContacts: [],
      searchTerm: "",
      loadingContacts: false,
      showModal: false,
      searchError: false,
    }
    this.filterContacts = debounce(this.filterContacts.bind(this), 500)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.selectContact = this.selectContact.bind(this)
    this.importContact = this.importContact.bind(this)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.filterFieldsChanged(prevState)) {
      this.setState({ loadingContacts: true })
      this.filterContacts()
    }
  }

  filterFieldsChanged(prevState) {
    return prevState.searchTerm !== this.state.searchTerm
  }

  filterContacts() {
    if (this.filterCriteriaMet()) {
      this.setState({ searchError: false })
      $.post(
        this.props.filterContactsPath,
        {
          name: this.state.searchTerm,
          email: this.state.searchTerm,
          phone: this.state.searchTerm,
        },
        (data) => {
          this.setState({
            contacts: data.contacts,
            users: data.users,
            safeHarborContacts: data.group_contacts,
            archivedContacts: data.archived_contacts,
            archivedContactsPath: data.archived_contacts_path,
            loadingContacts: false,
          })
        },
        "json"
      ).fail(() => {
        this.setState({
          loadingContacts: false,
          searchError: true,
        })
      })
    } else {
      this.setState({
        contacts: [],
        users: [],
        safeHarborContacts: [],
        archivedContacts: [],
        archivedContactsPath: null,
        searchError: false,
      })
    }
  }

  filterCriteriaMet() {
    return this.state.searchTerm.length >= 2
  }

  foundContacts() {
    const marinaContacts = this.state.contacts
    const safeHarborContacts = this.state.safeHarborContacts
    const dockwaUsers = this.state.users
    const archivedContacts = this.state.archivedContacts

    if (marinaContacts.length) {
      return { type: "direct", records: marinaContacts }
    } else if (archivedContacts && archivedContacts.length) {
      return { type: "archived", records: archivedContacts }
    } else if (safeHarborContacts.length) {
      return { type: "safe_harbor", records: safeHarborContacts }
    } else if (dockwaUsers.length) {
      return { type: "dockwa", records: dockwaUsers }
    } else {
      return { type: null, records: [] }
    }
  }

  selectContact(contact) {
    if (this.state.showModal === true) {
      this.trackEvent("create_new_customer")
    } else {
      this.trackEvent("create_add_customer")
    }
    this.closeModal()
    this.props.selectContact(contact)
  }

  trackEvent(eventName) {
    if (this.props.trackEvent) {
      this.props.trackEvent(eventName)
    }
  }

  importContact(baseImportPath, contactId) {
    if (baseImportPath === this.props.userImportPath) {
      this.trackEvent("create_import_dockwa_customer")
    } else if (baseImportPath === this.props.brewerImportPath) {
      this.trackEvent("create_import_shm_customer")
    }

    const importPath = `${baseImportPath}/${contactId}`
    if (this.props.isContract || this.props.twoColumnView) {
      $.get(
        importPath,
        (data) => {
          this.props.selectContact(data)
        },
        "json"
      )
    } else {
      window.location.href = importPath
    }
  }

  newContactUrl() {
    return this.props.manageContactsPath
  }

  renderSearchInstructions() {
    if (this.props.twoColumnView) {
      if (this.props.isSafeHarborLocation) {
        return (
          <p>
            Search for an existing customer using name or email. Search by email
            to locate and import Dockwa or Safe Harbor Customers.
          </p>
        )
      } else {
        return (
          <p>
            Search for an existing customer using name or email. Search by email
            to locate and import Dockwa Customers.
          </p>
        )
      }
    } else {
      if (this.props.isSafeHarborLocation) {
        return (
          <p>
            Search for an existing customer using name, phone, or email. Search
            by email to locate and import Dockwa or SafeHarbor Customers.
          </p>
        )
      } else {
        return (
          <p>
            Search for an existing customer using name, phone, or email. Search
            by email to locate and import Dockwa Customers.
          </p>
        )
      }
    }
  }

  renderTableBody() {
    if (this.state.searchError) {
      return (
        <tbody>
          <tr>
            <td
              className="bg-gray-100 px-4 py-8 text-center text-gray-800"
              colSpan="4"
            >
              <p>
                An error has occurred, please try again or contact Dockwa
                support.
              </p>
              <i
                className="icon icon-cancel-circle text-danger bs-mr-3"
                style={{ fontSize: "2rem" }}
              />
            </td>
          </tr>
        </tbody>
      )
    } else if (this.filterCriteriaMet() && this.state.loadingContacts) {
      return (
        <tbody>
          <tr>
            <td
              className="bg-gray-100 px-4 py-8 text-center text-gray-800"
              colSpan="4"
            >
              <p>Searching Customers...</p>
              <i className="icon icon-spinner icon-spin" />
            </td>
          </tr>
        </tbody>
      )
    } else if (this.foundContacts().type) {
      return (
        <ContactList
          twoColumnView={this.props.twoColumnView}
          contactVariant={this.foundContacts().type}
          contactsToList={this.foundContacts().records}
          selectContact={this.selectContact}
          importContact={this.importContact}
          brewerImportPath={this.props.brewerImportPath}
          manageContactsPath={this.props.manageContactsPath}
          userImportPath={this.props.userImportPath}
          archivedContactsPath={this.state.archivedContactsPath}
        />
      )
    } else if (this.filterCriteriaMet()) {
      return (
        <tbody>
          <tr>
            <td
              className="bg-gray-100 py-8 text-center text-gray-800"
              colSpan="4"
            >
              <div className="mb-1">No match found.</div>
              <button
                className="btn btn-sm btn-primary"
                type="button"
                onClick={this.openModal}
              >
                Create new customer
              </button>
            </td>
          </tr>
        </tbody>
      )
    } else {
      return (
        <tbody>
          <tr>
            <td
              className="bg-gray-100 px-4 py-8 text-center text-gray-800"
              colSpan="4"
            >
              {this.renderSearchInstructions()}
              <button
                className="btn btn-primary"
                type="button"
                onClick={this.openModal}
              >
                Create new customer
              </button>
            </td>
          </tr>
        </tbody>
      )
    }
  }

  render() {
    return (
      <div>
        <FormGroup
          label="Search Name or Email"
          name="searchTerm"
          onChange={this.handleInputChange}
          value={this.state.searchTerm}
          className="mb-0"
        />
        <table className="mt-2 w-full table-fixed">
          <thead className="sr-only">
            <tr>
              <th>Name</th>
              <th>Email</th>
              {!this.props.twoColumnView && <th>Phone</th>}
              {!this.props.twoColumnView && <th>View Contact</th>}
              {!this.props.twoColumnView && <th>Select Contact</th>}
            </tr>
          </thead>
          {this.renderTableBody()}
        </table>
        <CreateCustomerModal
          name={this.state.searchTerm}
          postUrl={this.newContactUrl()}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          phoneOptional={this.props.isContract || this.props.twoColumnView}
          selectContact={this.selectContact}
          isSafeHarborLocation={this.props.isSafeHarborLocation}
        />
      </div>
    )
  }
}

SearchCustomerForm.propTypes = {
  filterContactsPath: PropTypes.string.isRequired,
  manageContactsPath: PropTypes.string.isRequired,
  userImportPath: PropTypes.string,
  brewerImportPath: PropTypes.string,
  selectContact: PropTypes.func.isRequired,
  trackEvent: PropTypes.func,
  isContract: PropTypes.bool,
  twoColumnView: PropTypes.bool,
  isSafeHarborLocation: PropTypes.bool,
}

export default SearchCustomerForm
